import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCaller } from './honeycomb-api/api-caller';
import { RequestParams } from './honeycomb-api/assets/request-params.model';
import { HttpMethod } from './honeycomb-api/assets/http-method.enum';
import { RequestParam } from './honeycomb-api/assets/request-param.model';
import { RequestParamType } from './honeycomb-api/assets/request-param-type.enum';

export interface StorageSaveResult {
    message: string;
}

@Injectable({
    providedIn: 'root'
})
export class ConfigStorageService {

    private readonly controllerRoute = 'api/TenantAdmin/storage';

    constructor(private apiCaller: ApiCaller) {}

    /** GET /api/TenantAdmin/storage/entity/{entity}/{name} */
    getEntity<T>(entity: string, name: string): Observable<T> {
        const args = [
            new RequestParam('entity', RequestParamType.ROUTE, entity),
            new RequestParam('name', RequestParamType.ROUTE, name)
        ];
        const requestParams = new RequestParams('entity/{entity}/{name}', HttpMethod.GET, args);
        return this.apiCaller.request(this.controllerRoute, requestParams) as Observable<T>;
    }

    /** GET /api/TenantAdmin/storage/entity/{entity} */
    getAllEntities<T>(entity: string): Observable<T[]> {
        const args = [
            new RequestParam('entity', RequestParamType.ROUTE, entity)
        ];
        const requestParams = new RequestParams('entity/{entity}', HttpMethod.GET, args);
        return this.apiCaller.request(this.controllerRoute, requestParams) as Observable<T[]>;
    }

    /** POST /api/TenantAdmin/storage/entity/{entity}/{name} */
    saveEntity<T>(entity: string, name: string, content: T): Observable<StorageSaveResult> {
        const args = [
            new RequestParam('entity', RequestParamType.ROUTE, entity),
            new RequestParam('name', RequestParamType.ROUTE, name),
            new RequestParam('content', RequestParamType.BODY, content)
        ];
        const requestParams = new RequestParams('entity/{entity}/{name}', HttpMethod.POST, args);
        return this.apiCaller.request(this.controllerRoute, requestParams) as Observable<StorageSaveResult>;
    }

    /** GET /api/TenantAdmin/storage/dashboardStructure */
    getDashboardStructure(): Observable<string[]> {
        const requestParams = new RequestParams('dashboardStructure', HttpMethod.GET, []);
        return this.apiCaller.request(this.controllerRoute, requestParams) as Observable<string[]>;
    }

    /** GET /api/TenantAdmin/storage/widgetStructure */
    getWidgetStructure(): Observable<string[]> {
        const requestParams = new RequestParams('widgetStructure', HttpMethod.GET, []);
        return this.apiCaller.request(this.controllerRoute, requestParams) as Observable<string[]>;
    }
}
